export default {
  // Dashboard
  'dashboard.title': '대시보드',
  'dashboard.overview': '개요',
  'dashboard.qrcodes': 'QR 코드',
  'dashboard.links': '단축 링크',
  'dashboard.biolinks': '바이오 링크',
  'dashboard.analytics': '분석',
  
  // Stats
  'stats.totalClicks': '총 클릭',
  'stats.totalScans': '총 스캔',
  'stats.totalViews': '총 조회',
  'stats.today': '오늘',
  'stats.growth': '성장률',
  
  // QR Code
  'qr.create': 'QR 코드 생성',
  'qr.name': 'QR 코드 이름',
  'qr.url': '대상 URL',
  'qr.color': 'QR 색상',
  'qr.bgColor': '배경 색상',
  'qr.size': '크기',
  'qr.preview': '미리보기',
  'qr.download': '다운로드',
  'qr.scans': '스캔',
  'qr.created': '생성일',
  'qr.lastScanned': '마지막 스캔',
  'qr.noScans': '아직 스캔 없음',
  
  // Short Link
  'link.create': '단축 링크 생성',
  'link.name': '링크 이름',
  'link.original': '원본 URL',
  'link.short': '단축 코드',
  'link.clicks': '클릭',
  'link.copy': '복사',
  'link.copied': '복사됨!',
  
  // Bio Link
  'bio.create': '바이오 링크 생성',
  'bio.username': '사용자명',
  'bio.title': '제목',
  'bio.bio': '소개',
  'bio.avatar': '프로필 이미지',
  'bio.addLink': '링크 추가',
  'bio.linkTitle': '링크 제목',
  'bio.linkUrl': '링크 URL',
  'bio.theme': '테마',
  'bio.light': '라이트',
  'bio.dark': '다크',
  'bio.accentColor': '강조 색상',
  'bio.preview': '미리보기',
  'bio.views': '조회',
  
  // Actions
  'action.create': '생성',
  'action.save': '저장',
  'action.cancel': '취소',
  'action.delete': '삭제',
  'action.edit': '수정',
  'action.view': '보기',
  'action.share': '공유',
  
  // Messages
  'message.created': '생성되었습니다',
  'message.updated': '업데이트되었습니다',
  'message.deleted': '삭제되었습니다',
  'message.error': '오류가 발생했습니다',
  'message.fillRequired': '필수 항목을 입력해주세요',
  
  // Navigation
  'nav.home': '홈',
  'nav.logout': '로그아웃',
};
